import { boot } from 'quasar/wrappers'
import { PushNotifications } from '@capacitor/push-notifications'
import { Capacitor } from '@capacitor/core'
import { App } from '@capacitor/app'
import { useFullyLoadedAndLoggedInStore } from '../stores/fullyLoadedAndLoggedIn.js'
import { prodDomain } from '../constants.js'

export default boot(async ({ app, router }) => {
  console.log('RJMDEBUG001 capicator boot')

  if (Capacitor.getPlatform() === 'ios') {
    console.log('RJMDEBUG001 capicator boot - ios only functions')
    PushNotifications.addListener('pushNotificationActionPerformed', (notification) => {
      console.log('RJMDEBUG001 pushNotificationActionPerformed')
      // This never fires because it is in background when notifications appear.
      // instead notification-tapped events are fired and there is a special ios on complete loading
      //  function that deals with these
    })
    window.addEventListener('notification-tapped', async (event) => {
      // console.log('RJMDEBUG001 notification-tapped')
      // console.log('RJMDEBUG001 event', event)
      if (typeof (event.detail) === 'undefined') {
        return
      }
      const url = event.detail
      if (typeof url !== 'string') {
        return
      }
      let route = url
      try {
        const parsed = new URL(url)
        if (parsed.hostname === prodDomain) {
          route = parsed.pathname + parsed.search + parsed.hash
        }
      } catch {
        // Not a valid URL (it may already be a route like "/social/chatroom/...")
      }
      if (router.currentRoute.value.fullPath === route) {
        console.log('RJMDEBUG001 notification-tapped already on the page')
        app.config.globalProperties.$bus.emit('scrollChatToBottom')
      } else {
        console.log('RJMDEBUG001 notification-tapped Navigating to', route)
        await router.push(route)
      }
    })
  }

  if (Capacitor.getPlatform() === 'android' || Capacitor.getPlatform() === 'ios') {
    console.log('RJMDEBUG001 capicator boot - ios and android functions')
    // When a push notification is recieved
    PushNotifications.addListener('pushNotificationReceived', (notification) => {
      console.log('RJMDEBUG001 pushNotificationReceived')
      // optionally show a local notification here
    })

    // Add on activate to global bus
    //  this is when app is in the background but comes to foreground
    //  needed so the chat window will go get new messages
    App.addListener('appStateChange', ({ isActive }) => {
      if (isActive) {
        app.config.globalProperties.$bus.emit('mobileapp-resumed')
      }
    })

    // Window event name -> bus event name
    const windowEventsToMap = {
      'transmissionManager-messagecomplete': 'transmissionManager-messagecomplete',
      'chatstore-resyncnow': 'chatstore-resyncnow',
      'external-back-button-press': 'external-back-button-press' // sent by android only
    }

    // I am registering a function to execute after all stores are loaded
    //  note: It can be passed in two ways
    //   1. if app is running it will call firebasePushTokenRefreshed
    //   2. if app is not running it is set as a preference and I call java function to retrieve it
    router.beforeEach(async (to, from, next) => {
      console.log('RJMDEBUG001 about to register window.addEventListener')
      window.addEventListener('firebasePushTokenRefreshed', (event) => {
        console.log('RJMDEBUG001 got event firebasePushTokenRefreshed')
        if (typeof (event.detail) === 'undefined') {
          console.log('RJMDEBUG001 ERROR event has no detail section')
          return
        }
        // console.log('RJMDEBUG001 event detail=', JSON.stringify(event.detail))
        const fullyLoadedAndLoggedInStore = useFullyLoadedAndLoggedInStore()
        fullyLoadedAndLoggedInStore.registerCall({
          callFn: async function ({ userManStore, chatStore }) {
            // console.log('RJMDEBUG001 LOADED CALL FUNCTION registerRotatedPushToken')
            await chatStore.registerRotatedPushToken({
              tokenValue: event.detail
            })
          }
        })
      })
      const fullyLoadedAndLoggedInStore = useFullyLoadedAndLoggedInStore()
      fullyLoadedAndLoggedInStore.registerCall({
        callFn: async function ({ userManStore, chatStore }) {
          const plugin = window.Capacitor.Plugins.FirebasePushToken
          if (!plugin) {
            console.log('RJMDEBUG001 FirebasePushToken plugin not available')
          } else {
            const result = await plugin.getLastPushToken()
            const token = result?.token
            if (token) {
              chatStore.registerRotatedPushToken({
                tokenValue: token
              })
            } else {
              // console.log('RJMDEBUG001 FirebasePushToken no token - this is normal if no rotation is set')
            }
          }
        }
      })
      if (!window.__rjmWindowEventsRegistered) {
        window.__rjmWindowEventsRegistered = true
        Object.keys(windowEventsToMap).forEach(function (windowEventName) {
          window.addEventListener(windowEventName, (event) => {
            // console.log('RJMDEBUG001 windowevent recieved ', windowEventName)
            app.config.globalProperties.$bus.emit(windowEventsToMap[windowEventName], event.detail)
          })
        })
      }
      fullyLoadedAndLoggedInStore.registerCall({
        callFn: async function ({ userManStore, chatStore }) {
          // console.log('RJMDEBUG001 loaded and logged in check sent messages')
          const plugin = window.Capacitor.Plugins.TransmissionExecutor
          if (!plugin) {
            console.log('RJMDEBUG001 ERROR TransmissionExecutor plugin not available')
          } else {
            const res = await plugin.getAndResetRecordedTransmissions()
            res.list.forEach(function (item) {
              // console.log('RJMDEBUG001 item', JSON.stringify(res))
              chatStore.messageTransmissionComplete(item)
            })
          }
        }
      })
      next()
    })
  } // if android or ios
  const fullyLoadedAndLoggedInStore222 = useFullyLoadedAndLoggedInStore()
  fullyLoadedAndLoggedInStore222.registerCall({
    callFn: async function ({ userManStore, chatStore }) {
      if (Capacitor.getPlatform() === 'ios') {
        setTimeout(async function () {
          console.log('RJMDEBUG001 capicator start up - checking for queued messages')
          const plugin = window.Capacitor.Plugins.WebviewNotification
          if (!plugin) {
            console.log('RJMDEBUG001 WebviewNotification plugin not available')
            return
          }
          const { events } = await plugin.collectQueuedMessages()
          console.log(`RJMDEBUG001 got ${events.length} queued events`)
        }, 100) // 1000 = 1 sec
      }
    }
  })
})
